import { render, staticRenderFns } from "./ApplicationsKanbanView.vue?vue&type=template&id=02c3bbe6&"
import script from "./ApplicationsKanbanView.vue?vue&type=script&lang=js&"
export * from "./ApplicationsKanbanView.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationsKanbanView.vue?vue&type=style&index=0&lang=scss&scopped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports